<template>
    <div>
<!--        <b-row class="mb-2">-->
<!--            <b-col class="text-right">-->
<!--                <b-button variant="primary" :to="{ name: 'GroupNew', params: { customerId: this.customer.id }}">-->
<!--                    <font-awesome-icon icon="plus"></font-awesome-icon> Nuevo-->
<!--                </b-button>-->
<!--            </b-col>-->
<!--        </b-row>-->
        <GroupForm :settings="settings" :customer="customer" @update-groups-data="updateGroupsData"></GroupForm>

        <b-row class="mt-5 mb-2">
            <b-col sm="5" md="6" class="my-1">
                <b-input-group size="sm" prepend="Mostrar" append="registros">
                    <b-form-select v-model="groups.itemsPerPage" id="perPageSelect" size="sm" :options="groups.pageOptions"
                                   style="max-width: 5em"></b-form-select>
                </b-input-group>
            </b-col>

            <b-col sm="7" md="6" class="my-1">
                <b-input-group prepend="Filtrar: ">
                    <b-input v-model="groups.filter" debounce="300"></b-input>
                </b-input-group>
            </b-col>
        </b-row>
        <b-table :items="loadData" :fields="groups.fields" :filter="groups.filter" :current-page="groups.currentPage"
                 :per-page="groups.itemsPerPage" empty-text="Sin registros" empty-filtered-text="Sin coincidencias"
                 striped bordered hover small show-empty :responsive="true" :sort-by.sync="groups.sortBy" ref="groupsTable"
                 class="text-left">
            <template v-slot:thead-top>
                <b-tr>
                    <b-th v-for="(field, index) in groups.fields" :key="field.key">
                        <b-row v-if="groups.filters[index]">
                            <b-col v-if="groups.filters[index].inputType === 'Select'">
                                <b-select v-model="groups.filters[index].value">
                                    <b-select-option value="">Todos</b-select-option>
                                    <b-select-option value="TRUE">Activo</b-select-option>
                                    <b-select-option value="FALSE">Inactivo</b-select-option>
                                </b-select>
                            </b-col>
                            <b-col v-else-if="groups.filters[index].type === 'STRING'">
                                <b-input :placeholder="field.label" v-model="groups.filters[index].value" debounce="300"></b-input>
                            </b-col>
                        </b-row>
                    </b-th>
                </b-tr>
            </template>
            <!--                <template v-slot:cell(details)="row">-->
            <!--                    <div class="text-center">-->
            <!--                        <b-button size="sm" @click="row.toggleDetails" :variant="row.detailsShowing ? 'danger' : 'success'" pill>-->
            <!--                            <font-awesome-icon :icon="row.detailsShowing ? 'minus' : 'plus'"></font-awesome-icon>-->
            <!--                        </b-button>-->
            <!--                    </div>-->
            <!--                </template>-->
            <template v-slot:cell(name)="row">
                <b-input v-if="row.item.isEditing" v-model="row.item.name" placeholder="Nombre"></b-input>
                <span v-else>{{ row.item.name }}</span>
            </template>
            <!--                <template v-slot:cell(parent)="row">{{ row.item.parent ? row.item.parent : '' }}</template>-->
            <template v-slot:cell(users)="row">
                <template v-if="row.item.isEditing">
                    <v-select label="name" :options="users" debounce="300" placeholder="Usuarios" multiple
                              @search="getUsers" @search:focus="getUsers" :filterable="false" v-model="row.item.users">
                        <template slot="no-options">Sin resultados.</template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">{{ option.name }}</div>
                            <div class="d-center" v-if="option.email">{{ option.email }}</div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">{{ option.name }}</div>
                        </template>
                    </v-select>
                </template>
                <span v-else>
                        <template v-for="user in row.item.users">
                        <b-badge variant="primary" class="p-1 ml-1" :key="user.id">{{ user.name }}</b-badge>
                    </template>
                    </span>
            </template>
            <template v-slot:cell(enabled)="row">
                <div v-if="!row.item.isEditing" class="text-center">
                    <b-badge variant="primary" v-if="row.item.enabled" class="p-1">Activo</b-badge>
                    <b-badge variant="warning" v-else>Inactivo</b-badge>
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <div class="text-center">
                    <b-button-group size="sm">
                        <!--                            :to="{ name: 'GroupEdit', params: { id: row.item.id }}"-->
                        <b-button v-b-tooltip.hover :title="row.item.isEditing ? 'Cancelar' : 'Modificar'"
                                  variant="outline-primary" @click="toggleEditing(row.item)">
                            <font-awesome-icon v-if="row.item.isEditing" icon="ban"></font-awesome-icon>
                            <font-awesome-icon v-else icon="edit"></font-awesome-icon>
                        </b-button>
                        <b-button v-if="row.item.isEditing" v-b-tooltip.hover title="Guardar" variant="outline-primary"
                                  @click="saveGroup(row.item)">
                            <font-awesome-icon icon="save"></font-awesome-icon>
                        </b-button>
                        <b-button v-else v-b-tooltip.hover :title="row.item.enabled ? 'Desactivar' : 'Activar'"
                                  variant="outline-primary" @click="changeStatus(row.item)">
                            <font-awesome-icon :icon="row.item.enabled ? 'toggle-off' : 'toggle-on'"></font-awesome-icon>
                        </b-button>
                    </b-button-group>
                </div>
            </template>

            <!--                <template v-slot:row-details="row">-->
            <!--                    <b-card>-->
            <!--                        <b-row class="mb-2">-->
            <!--                            <b-col>-->
            <!--                                <b-list-group>-->
            <!--                                    <template v-if="row.item.children.length > 0">-->
            <!--                                        <b-list-group-item><b>Subgrupos</b></b-list-group-item>-->
            <!--                                        <b-list-group-item v-for="child in row.item.children" :key="child" class="py-1">{{ child }}</b-list-group-item>-->
            <!--                                    </template>-->
            <!--                                    <template v-else>-->
            <!--                                        <b-list-group-item class="text-center"><b>Sin subgrupos</b></b-list-group-item>-->
            <!--                                    </template>-->
            <!--                                </b-list-group>-->
            <!--                            </b-col>-->
            <!--                            <b-col>-->
            <!--                                <b-list-group>-->
            <!--                                    <template v-if="row.item.users.length > 0">-->
            <!--                                        <b-list-group-item><b>Usuarios</b></b-list-group-item>-->
            <!--                                        <b-list-group-item v-for="user in row.item.users" :key="user" class="py-1">{{ user }}</b-list-group-item>-->
            <!--                                    </template>-->
            <!--                                    <template v-else>-->
            <!--                                        <b-list-group-item class="text-center"><b>Sin usuarios</b></b-list-group-item>-->
            <!--                                    </template>-->
            <!--                                </b-list-group>-->
            <!--                            </b-col>-->
            <!--                        </b-row>-->
            <!--                    </b-card>-->
            <!--                </template>-->

            <template v-slot:table-caption>
                <b-row class="no-gutters">
                    <b-col sm="5" md="6">
                        Mostrando {{ start }} a {{ end }} de {{ groups.totalRows }} registro<template v-if="groups.totalRows !== 1">s</template>
                    </b-col>
                    <b-col sm="7" md="6" class="my-1">
                        <b-pagination v-model="groups.currentPage" :total-rows="groups.totalRows"
                                      :per-page="groups.itemsPerPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </template>
        </b-table>
    </div>
</template>

<script>
import GroupForm from '../Group/Form';
import { groupListUrl, groupEnableUrl, userListUrl, groupUrl } from '@routes';
import * as constants from '@constants';

export default {
    props: {
        settings: Object,
        membership: Object,
        customer: Object,
        groupsData: Array
    },
    data() {
        return {
            groups: {
                items: [],
                fields: [
                    // { key: 'id', label: 'id', sortable: true },
                    // { key: 'details', label: '' },
                    { key: 'name', label: 'Nombre', sortable: true },
                    // { key: 'parent', label: 'Grupo base', sortable: true },
                    { key: 'users', label: 'Usuarios', sortable: false },
                    { key: 'enabled', label: 'Estatus', sortable: true },
                    { key: 'actions', label: 'Acciones' }
                ],
                filters: [
                    // false,
                    { column: 'pg.name', type: 'STRING', value: '', format: '' },
                    // { column: 'pgp.name', type: 'STRING', value: '', format: '' },
                    false,
                    { column: 'pg.enabled', type: 'BOOLEAN', value: '', format: '', inputType: 'Select' }
                ],
                filter: '',
                isLoading: false,
                pageOptions: [25, 50, 75, 100],
                totalRows: 0,
                currentPage: 1,
                itemsPerPage: 25,
                sortBy: 'pg.id',
                sortDesc: false
            },
            groupsCache: [],
            users: []
        }
    },
    components: {
        GroupForm
    },
    methods: {
        loadData(ctx) {
            if (ctx.sortBy !== '') {
                let data = {
                    customerId: this.customer.id,
                    filters: this.groups.filters.filter(filter => filter ? filter.value.trim() !== '' : false),
                    ...ctx
                };

                data.currentPage = (data.currentPage - 1) * data.perPage;

                return this.axios.post(groupListUrl(), data).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        this.groups.totalRows = response.data.totalRows;

                        response.data.groups.forEach(group => {
                            group.isEditing = false;
                        });

                        return response.data.groups;
                    } else {
                        return [];
                    }
                }).catch(error => {
                    console.error(error);

                    return [];
                });
            }
        },
        changeStatus(group) {
            this.$swal({
                title: `¿${group.enabled ? 'Desactivar' : 'Activar'} el grupo ${group.name}?`,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    this.axios.put(groupEnableUrl(), {
                        application: this.application,
                        groupId: group.id,
                        enabled: !group.enabled
                    }).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            group.enabled = !group.enabled;

                            this.$bvToast.toast(response.data.message, {
                                variant: 'success'
                            });

                            this.$refs.groupsTable.refresh();
                        }
                    }).catch(() => {
                        this.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                            variant: 'danger'
                        });
                    });
                }
            });
        },
        updateGroupsData() {
            this.$refs.groupsTable.refresh();
        },
        getUsers(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(userListUrl(), {
                params: {
                    searchWord: search,
                    application: constants.PORTAL_USER,
                    customerId: this.customer.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.users = response.data.users;
                } else {
                    this.users = [];
                }
            }).catch(() => {
                this.users = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        toggleEditing(group) {
            if (group.isEditing) {
                let index = this.groupsCache.findIndex(item => item.id === group.id);

                if (index >= 0) {
                    for (let prop in group) {
                        group[prop] = this.groupsCache[index][prop];
                    }

                    this.groupsCache.splice(index, 1);
                }

                group.isEditing = false;
            } else {
                this.groupsCache.push({ ...group });

                group.isEditing = true;
            }
        },
        saveGroup(group) {
            this.$swal({
                title: '¿Actualizar el grupo?',
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    let data = {
                        customerId: this.customer.id,
                        group: {
                            id: group.id,
                            name: group.name,
                            // parentId: group.parent ? group.parent.id : 0,
                            userIds: group.users.map(user => parseInt(user.id))
                        }
                    };

                    this.axios.put(groupUrl(), data).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            this.$root.$bvToast.toast(response.data.message, {
                                title: 'Grupos',
                                variant: 'success'
                            });

                            let index = this.groupsCache.findIndex(item => item.id === group.id);

                            if (index >= 0) {
                                this.groupsCache.splice(index, 1);
                            }

                            group.isEditing = false;

                            this.$refs.groupsTable.refresh();
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: 'Grupos',
                                variant: 'danger'
                            });
                        }
                    }).catch(error => {
                        console.error(error);

                        this.$bvToast.toast('Ocurrió un error al guardar el grupo.', {
                            title: 'Grupos',
                            variant: 'danger'
                        });
                    });
                }
            });
        }
    },
    watch: {
        'groups.filters': {
            handler() {
                this.$refs.groupsTable.refresh();
            },
            deep: true
        }
    },
    computed: {
        start: function() {
            return this.groups.totalRows === 0 ? 0 : (this.groups.currentPage - 1) * this.groups.itemsPerPage + 1;
        },
        end: function() {
            let offset = (this.groups.currentPage - 1) * this.groups.itemsPerPage;

            return (this.groups.totalRows - offset) < this.groups.itemsPerPage ? this.groups.totalRows : offset + this.groups.itemsPerPage;
        }
    }
}
</script>

<style scoped>

</style>